'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Modal = exports.actions = exports.reducers = exports.constants = undefined;

var _Container = require('./Container');

Object.defineProperty(exports, 'Modal', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Container).default;
    }
});

var _constants = require('./constants');

var constants = _interopRequireWildcard(_constants);

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = {
    modal: _reducer2.default
};
exports.constants = constants;
exports.reducers = reducers;
exports.actions = actions;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/modal-component/dist/main/index.js
// module id = 133
// module chunks = 0